type PendingMap = Record<string, boolean | null>;

function safeParse<T>(raw: string | null): T | null {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

const keyFor = (companyId: string | undefined, userId: string | undefined) => `tf:pending-answers:${companyId || 'unknown'}:${userId || 'unknown'}`;

export function readPending(companyId: string | undefined, userId: string | undefined): PendingMap {
  const raw = localStorage.getItem(keyFor(companyId, userId));
  return safeParse<PendingMap>(raw) || {};
}

export function mergePending(companyId: string | undefined, userId: string | undefined, patch: PendingMap): PendingMap {
  const current = readPending(companyId, userId);
  const next = { ...current, ...patch };
  localStorage.setItem(keyFor(companyId, userId), JSON.stringify(next));
  return next;
}

export function clearPending(companyId: string | undefined, userId: string | undefined): void {
  localStorage.removeItem(keyFor(companyId, userId));
}

export function hasPending(companyId: string | undefined, userId: string | undefined): boolean {
  const pending = readPending(companyId, userId);
  return Object.keys(pending).length > 0;
}
